<template>
	<div class="c-comment-renderer">
		<article v-html="comment" v-if="comment && !editable"></article>
		<Editor :note="note" v-if="editable"></Editor>
	</div>
</template>

<script>
import Editor from '@/components/ui/editor';

export default {
	components: {
		Editor,
	},
	props: ['note', 'editable'],
	watch: {
		comment: function () {
			if (this.note.comment && this.note.comment.raw) {
				console.log('comment triggered!');
			}
		},
	},
	computed: {
		comment: function () {
			if (this.note.comment && this.note.comment.raw) {
				return this.note.comment.html;
			} else {
				return false;
			}
		},
	},
};
</script>

<style lang="scss">
.c-comment-renderer {
	article,
	.c-editor {
		position: relative;
		margin-left: 40px;
		margin-top: var(--margin-lg);
		opacity: 0.9;
		font-size: var(--font-size-sm);

		&:before {
			content: '';
			position: absolute;
			top: 0;
			left: -30px;
			border-bottom-left-radius: 5px;
			border-left: var(--g1) solid 2px;
			border-bottom: var(--g1) solid 2px;
			width: 20px;
			height: 12px;
		}
	}

	.c-editor {
		min-height: 20px;
		&__textarea {
			> div {
				background-color: rgba(0, 0, 0, 0.15);

				&:hover {
					background-color: rgba(0, 0, 0, 0.25);
				}
			}
		}
	}
}
</style>